import { supabase } from '@/lib/supabaseClient'

export async function fetchNotifications({ unreadOnly = false, limit = 50 } = {}) {
  let query = supabase
    .from('notifications')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit)

  if (unreadOnly) {
    query = query.eq('read', false)
  }

  const { data, error } = await query

  if (error) throw error
  return { data, error: null }
}

export async function getNotificationCount() {
  const { data, error } = await supabase.rpc('get_notification_count')

  if (error) throw error
  return data || 0
}

export async function markNotificationsAsRead(notificationIds) {
  const { data, error } = await supabase.rpc('mark_notifications_read', {
    p_notification_ids: notificationIds,
  })

  if (error) throw error
  return data
}

export async function markAllNotificationsAsRead() {
  const { data: notifications } = await fetchNotifications({ unreadOnly: true })
  if (!notifications || notifications.length === 0) return 0

  const ids = notifications.map(n => n.id)
  return markNotificationsAsRead(ids)
}

export async function sendNotification(userId, type, title, message, options = {}) {
  const { data, error } = await supabase.rpc('send_notification', {
    p_user_id: userId,
    p_type: type,
    p_title: title,
    p_message: message,
    p_link: options.link || null,
    p_priority: options.priority || 'normal',
    p_metadata: options.metadata || {},
  })

  if (error) throw error
  return data
}

export function subscribeToNotifications(userId, callback) {
  const channel = supabase
    .channel('notifications')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'notifications',
        filter: `user_id=eq.${userId}`,
      },
      (payload) => {
        callback(payload.new)
      }
    )
    .subscribe()

  return () => {
    supabase.removeChannel(channel)
  }
}
